<template>
  <div class="emails-input">
    <div class="form-group row" :class="{ 'has-feedback' : isDirty }">
      <label :for="options.name" :class="options.fullWidth ? 'col-sm-12' : 'col-sm-3 col-form-label'">
        {{ options.label }}
        <span v-if="options.required" class="required">*</span>
      </label>
      <div :class="options.fullWidth ? 'col-sm-12' : 'col-sm-9'">
        <input class="form-control" type="text"
          :id="options.name"
          :value="textVal"
          :class="formControlValidationClass"
          :name="options.name"
          @input="validate($event.target.value)"/>
        <span :class="validationClass" v-show="validationMessage">
          {{ validationMessage }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import {
  validationClass,
  formControlValidationClass,
  validationMessage
} from '@/util/helpers'

export default {
  name: 'EmailsInput',
  props: {
    value: {
      type: Array
    },
    options: {
      type: Object,
      default () {
        return {
          name: '',
          label: ''
        }
      }
    }
  },
  computed: {
    formControlValidationClass,
    validationClass,
    validationMessage,
    invalidMessage () {
      if (!this.value) {
        return this.options.label + ' is required'
      } else if (this.invalidEmails.length) {
        let message = ''
        for (let email of this.invalidEmails) {
          message += email
          if (email !== this.invalidEmails[this.invalidEmails.length - 1]) {
            message += ', '
          }
        }
        if (this.invalidEmails.length === 1) {
          message += ' is not a valid email address'
        } else {
          message += ' are not valid email addresses'
        }
        return message
      }
    }
  },
  data () {
    return {
      regex: /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/,
      isRegex: false,
      isValid: false,
      isDirty: false,
      invalidEmails: [],
      textVal: ''
    }
  },
  mounted () {
    this.textVal = this.value.join(',')
  },
  methods: {
    validate (val = this.value) {
      this.textVal = val
      if (!Array.isArray(val)) {
        val = val.split(/,\s*/)
      }
      this.$emit('input', val)
      this.isDirty = true
      if (val && val.length) {
        this.invalidEmails = []
        for (let email of val) {
          if (!email) val.splice(val.indexOf(email), 1)
          else {
            email = email.toLowerCase()
            if (!new RegExp(this.regex).test(email)) {
              this.invalidEmails.push(email)
            }
          }
        }
        if (this.invalidEmails.length) {
          this.isValid = this.isRegex = false
        } else {
          this.isValid = this.isRegex = true
        }
      } else if (this.options.required) {
        this.isValid = false
      } else {
        this.isValid = true
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/inputs/EmailsInput.vue